/**
 * 应用版本号显示组件
 * 在侧边栏底部显示当前应用版本号
 * 点击可查看版本更新记录
 */

import React, { useState } from 'react';
import { Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import ChangelogModal from '../ChangelogModal';
import './index.less';

export interface AppVersionProps {
  /**
   * 是否折叠模式（侧边栏收起时）
   */
  collapsed?: boolean;
  /**
   * 主题：dark 深色（用于侧边栏），light 浅色
   */
  theme?: 'dark' | 'light';
  /**
   * 自定义类名
   */
  className?: string;
}

const AppVersion: React.FC<AppVersionProps> = ({
  collapsed = false,
  theme = 'dark',
  className = '',
}) => {
  const { t } = useTranslation();
  const [modalOpen, setModalOpen] = useState(false);

  const version = __APP_VERSION__;
  const buildTime = __BUILD_TIME__;

  // 格式化构建时间
  const formatBuildTime = (isoString: string) => {
    try {
      const date = new Date(isoString);
      return date.toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
      });
    } catch {
      return isoString;
    }
  };

  const handleClick = () => {
    setModalOpen(true);
  };

  const tooltipContent = (
    <div className="app-version-tooltip">
      <div>{t('changelog.version')}: v{version}</div>
      <div>{t('changelog.buildTime')}: {formatBuildTime(buildTime)}</div>
      <div className="app-version-hint">{t('changelog.clickToView')}</div>
    </div>
  );

  return (
    <>
      <div className={`app-version app-version-${theme} ${collapsed ? 'collapsed' : ''} ${className}`}>
        <Tooltip title={tooltipContent} placement="right">
          <span className="version-text" onClick={handleClick}>
            {collapsed ? `v${version.split('.')[0]}` : `v${version}`}
          </span>
        </Tooltip>
      </div>
      <ChangelogModal open={modalOpen} onClose={() => setModalOpen(false)} />
    </>
  );
};

export default AppVersion;
